<div class="accordion-item" [class.open]="isOpen()">
  <button class="accordion-header" (click)="toggle()" [attr.aria-expanded]="isOpen()">
    <span class="question">{{ item.faqQuestion }}</span>
    <span class="icon">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 5V19M5 12H19"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  </button>
  <div class="accordion-content" [style.max-height]="isOpen() ? '500px' : '0'">
    <div class="content-inner">
      <p>{{ item.faqAnswer }}</p>
    </div>
  </div>
</div>
